
function SiteBanNotification() {
  this.hoursMuted = 3;
  this.queueNoty = 'siteBanNotification';
  this.keyLocalStorage = 'siteBanMuted';
}

SiteBanNotification.prototype.hideAllNotifications = function() {
  // Fechar todas as notificações que pertencem à mesma fila
  Noty.closeAll(this.queueNoty);
};

SiteBanNotification.prototype.muteNotification = function(expireTimeInSeconds) {
  var siteBanMuted = JSON.parse(window.localStorage.getItem(this.keyLocalStorage));
  if (!siteBanMuted) {
    siteBanMuted = {};
  }

  if (expireTimeInSeconds) {
    var expire_at = new Date().getTime() + (expireTimeInSeconds * 1000);
  } else {
    var expire_at = new Date().getTime() + (3600000 * this.hoursMuted); // 3600000 = 1h
  }

  siteBanMuted[window.PLAYERID] = { player_id: window.PLAYERID, expire_at: expire_at };

  // Seta no LocalStorage que o usuário quer silenciar a notificação
  window.localStorage.setItem(this.keyLocalStorage, JSON.stringify(siteBanMuted));

  // Após salvar a preferência do usuário, oculte as notificações atuais de ban
  this.hideAllNotifications();
};

SiteBanNotification.prototype.isMutedNotification = function() {
  var siteBanMutedOriginal = JSON.parse(window.localStorage.getItem(this.keyLocalStorage));
  if (!siteBanMutedOriginal) {
    return false;
  }

  // Pega apenas os itens que ainda não expiraram
  var siteBanMuted = {};
  for (idItem in siteBanMutedOriginal) {
    var item = siteBanMutedOriginal[idItem];
    if (item.expire_at > new Date().getTime()) {
      siteBanMuted[item.player_id] = item;
    }
  }

  // Se removeu algum item da lista por estar expirado, devemos atualizar no LocalStorage
  if (Object.keys(siteBanMutedOriginal).length !== Object.keys(siteBanMuted).length) {
    if (Object.keys(siteBanMuted).length === 0) {
      window.localStorage.removeItem(this.keyLocalStorage);
    } else {
      window.localStorage.setItem(this.keyLocalStorage, JSON.stringify(siteBanMuted));
    }
  }

  return typeof siteBanMuted[window.PLAYERID] !== 'undefined';
};

SiteBanNotification.prototype.canShowNotification = function() {
  return (!window.GamersClub ||
    !window.GamersClub.player ||
    !window.GamersClub.player.settings ||
    typeof window.GamersClub.player.settings.disable_ban_site_notification === 'undefined' ||
    window.GamersClub.player.settings.disable_ban_site_notification === 'false') &&
    (typeof gameOn === 'undefined' || !gameOn) &&
    !this.isMutedNotification();
}

SiteBanNotification.prototype.showNotification = function(data) {
  if (!data || !this.canShowNotification()) {
    return;
  }

  // Trabalha os dados vindo do Socket
  var data = JSON.parse(data);

  // Monta e exibe a notificação de ban
  new Noty({
    // Estilos e Configurações
    queue: this.queueNoty,
    type: this.queueNoty,
    timeout: 5000,
    layout: 'topRight',
    animation: {
      open : 'animated fadeInRight',
      close: 'animated fadeOutRight'
    },

    // Conteúdos
    text: i18n.ban_site_message.replace('{nickname}', data.nick),
    total_ban: data.bans,
    total_ban_link: '/blockeds',
    total_ban_text: i18n.ban_site_total,
    dismiss_link: '/settings#notifications',
    dismiss_text: i18n.ban_site_dismiss,
    mute_text: i18n.ban_site_mute.replace('%s', this.hoursMuted),
    close_all_text: i18n.ban_site_tooltip_close_all,

    // Template
    callbacks: {
      onTemplate: function() {
        var innerHTML = '<div class="noty-siteban noty_body">';
        innerHTML += '<span class="noty-closeAll-button" title="' + this.options.close_all_text + '" onclick="window.siteBanNotification.hideAllNotifications()"></span>';
        innerHTML += '<div class="noty-siteban-content">';
        innerHTML += '<div class="noty-siteban-text">' + this.options.text + '</div>';
        innerHTML += '<span class="noty-siteban-total-ban">';
        innerHTML += '<a href="' + this.options.total_ban_link + '" target="_blank" class="noty-siteban-total-ban-link">' + this.options.total_ban + '</a> ';
        innerHTML += this.options.total_ban_text;
        innerHTML += '</span>';
        innerHTML += '</div>';
        innerHTML += '<div class="noty-siteban-footer">';
        innerHTML += '<a class="noty-siteban-footer-link noty-siteban-footer-mute" onclick="window.siteBanNotification.muteNotification()">';
        innerHTML += '<i class="fa fa-bell-slash" aria-hidden="true"></i>' + this.options.mute_text;
        innerHTML += '</a>';
        innerHTML += '<a href="' + this.options.dismiss_link + '" target="_blank" class="noty-siteban-footer-link noty-siteban-footer-dismiss">';
        innerHTML += '<i class="fa fa-eye-slash" aria-hidden="true"></i>' + this.options.dismiss_text;
        innerHTML += '</a>';
        innerHTML += '</div>';

        this.barDom.innerHTML = innerHTML;
      }
    }
  }).show();
}

var siteBanNotification = new SiteBanNotification();